package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.certificates.CertificatesScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_strikeradar_certificates
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteLightningCertificatesNormal : RouteParameterTo

object RouterLightningCertificatesNormal : RouterNoParameters<RouteLightningCertificatesNormal>(
    RouteLightningCertificatesNormal::class
) {
    override fun routeFrom(parameters: RouteLightningCertificatesNormal) =
        "/certificates/normal"

    @Composable
    override fun Show(parameters: RouteLightningCertificatesNormal) {
        RouteLightningCertificatesNormalImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteLightningCertificatesNormal,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteLightningCertificatesNormal

    override fun isMatching(route: String) = route == "/certificates/normal"

    override fun navigateFrom(path: String) = RouteLightningCertificatesNormal
}

class RouteLightningCertificatesNormalImpl : Route<RouteLightningCertificatesNormal>(
    route = "/certificates/normal",
    params = RouteLightningCertificatesNormal,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        CertificatesScreen(state.apiProvider!!.apiNormal)
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_strikeradar_certificates,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        appModel.logout()
                    }
                )
            )
        )
    }
}
